import { useQuery } from '@tanstack/react-query';
import Markdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { helpApi } from '../api/help';
import { useAuth } from '../auth/AuthContext';
import { ProblemAlert } from './ui';

/** The role guide from docs/roles/ for the current role. A tester who switches role gets the new role's guide. */
export function HelpPage() {
  const { user } = useAuth();
  const guide = useQuery({ queryKey: ['help', 'me', user?.id, user?.roles.join(',')], queryFn: helpApi.mine });
  if (guide.isLoading) return <p className="muted">Loading…</p>;
  if (guide.error || !guide.data) return <ProblemAlert error={guide.error ?? new Error('No guide was returned')} />;
  return (
    <article className="doc">
      <Markdown remarkPlugins={[remarkGfm]}>{guide.data.markdown}</Markdown>
    </article>
  );
}
